import {
  Descriptions,
  Table,
  Tag,
  Tooltip,
  Typography,
  Input,
  Button,
  Space,
  InputNumber,
} from "antd";
import React, { useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";

const StockSelection = (props) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState(props.selectedIds);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [selectedStocks, setSelectedStocks] = useState([]);
  const [stocks, setStocks] = useState(props.stocks);
  const searchInput = useRef(null);
  //console.log("SelectedIds:", selectedStocks);

  const { Text } = Typography;

  const onSelectChange = (selectedRowKeys) => {
    setSelectedRowKeys(selectedRowKeys);
    const selectedItems = props.stocks.filter((item) =>
      selectedRowKeys.includes(item.id)
    );
    //console.log("SelectStocks:", selectedItems);
    setSelectedStocks(selectedItems);
    props.onSelectChange(selectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? dataIndex === "runningNo"
          ? record[dataIndex].toString().toLowerCase() === value.toLowerCase()
          : record[dataIndex]
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(
          () =>
            searchInput && searchInput.current && searchInput.current.select(),
          100
        );
      }
    },
    render: (text) => (searchedColumn === dataIndex ? text : text),
  });

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getRowByKey = (key, newData) =>
    (newData || stocks)?.filter((item) => item.id === key)[0];

  const handleFieldChange = (value, fieldName, key) => {
    /* props.stocks.forEach((item) => {
      if (item.id === key) {
        if (["issueQuantity"].includes(fieldName)) {
          item.issueQuantity = value;
          props.onQuantityChange(item.id, value);
        }
      }
    }); */
    const newData = [...stocks];
    const target = getRowByKey(key, newData);
    if (target) {
      if (["stockType", "lotNumber", "measurementType"].includes(fieldName)) {
        target[fieldName] = { id: value };
      } else {
        target[fieldName] = value;
      }

      if (["issueQuantity"].includes(fieldName)) {
        props.onQuantityChange(target.id, value);
      }
      setStocks(newData);
      setSelectedRowKeys([...selectedRowKeys, target.stockType.id]);
      props.onSelectChange(selectedRowKeys);
    }
  };

  const getColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      dataIndex: "stockType",
      key: "stockType",
      //width: "8%",
      render: (text, record) => {
        return record.stockType.code;
      },
    });
    columns.push({
      title: "Description",
      key: "materialName",
      width: "30%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    });
    columns.push({
      title: "Stock Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      render: (text, record) => {
        return record.stockBin.code;
      },
      //width: "7%",
      defaultSortOrder: "ascend",
      sorter: (a, b) => a.stockBin.code.localeCompare(b.stockBin.code),
    });
    /* columns.push({
      title: "Roll/Box No",
      dataIndex: "runningNo",
      key: "runningNo",
      width: "5%",
      defaultSortOrder: "descend",
      sorter: (a, b) => parseInt(a.runningNo) < parseInt(b.runningNo),
      ...getColumnSearchProps("runningNo"),
    }); */
    /* columns.push({
      title: "Stock Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      width: "10%",
      render: (text, record) => {
        return record.stockBin.code;
      },
    }); */
    columns.push({
      title: "Invoice No:",
      key: "invoiceNumber",
      //width: "15%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          record.stockPreReceiptLine.stockPreReceipt.preReceiptNumber
        );
      },
    });
    columns.push({
      title: "Custom Ref. No:",
      key: "customRefNumber",
      //width: "15%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          record.stockPreReceiptLine.stockPreReceipt.refNumber
        );
      },
    });
    /* columns.push({
      title: "Invoice Date",
      //dataIndex: "createdAt",
      key: "createdAt",
      width: "8%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(record.stockPreReceiptLine.stockPreReceipt.orderDate).format(
            "YYYY-MM-DD"
          )
        );
      },
    }); */
    columns.push({
      title: "Receipt Type",
      dataIndex: "receiptType",
      key: "receiptType",
      //width: "8%",
      render: (text) => {
        let color = "";
        if (text === "TIEP") {
          color = "#87d068";
        }
        if (text === "NON_TIEP") {
          color = "#2db7f5";
        }
        if (text === "LOCAL") {
          color = "#108ee9";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      //width: "8%",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      align: "right",
    });
    columns.push({
      title: "Issue Qty",
      dataIndex: "issueQuantity",
      key: "issueQuantity",
      align: "right",
      width: "10%",
      render: (text, record) => {
        return (
          <InputNumber
            value={text}
            onChange={(e) => handleFieldChange(e, "issueQuantity", record.id)}
            min={0}
            placeholder="Issue Quantity"
          />
        );
      },
    });
    /* columns.push({
      title: "Net Weight",
      dataIndex: "netWeight",
      key: "netWeight",
      align: "right",
      width: "6%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
      ...getColumnSearchProps("netWeight"),
    }); */
    /* columns.push({
      title: "Gross Weight",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      width: "6%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
      ...getColumnSearchProps("grossWeight"),
    }); */
    /* columns.push({
      title: "Gross (Sq.m)",
      dataIndex: "grossValueSqm",
      key: "grossValueSqm",
      align: "right",
      width: "5%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
      ...getColumnSearchProps("grossValueSqm"),
    }); */
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "5%",
      render: (text, record) => {
        return record.measurementType && record.measurementType.name;
      },
    });
    columns.push({
      title: "Age",
      key: "dueDays",
      width: "4%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(moment()).diff(
            record.stockPreReceiptLine.stockPreReceipt.orderDate,
            "days"
          )
        );
      },
    });

    return columns;
  };

  return (
    <div>
      <Table
        bordered
        rowKey="id"
        size="small"
        columns={getColumns()}
        dataSource={stocks}
        pagination={{
          showSizeChanger: true,
          showTotal: (total) => `Total ${total} items`,
          pageSizeOptions: [10, 20, 50, 100, 200, 500, 1000],
        }}
        rowSelection={rowSelection}
        summary={(pageData) => {
          let totalIssueQuantity = 0;

          pageData.forEach(({ issueQuantity }) => {
            totalIssueQuantity += issueQuantity;
          });

          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={8}>
                  <Text strong>Total</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  <Text strong style={{ paddingLeft: 12 }}>
                    {props.stocks && props.stocks.length}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <Text strong style={{ paddingLeft: 12 }}>
                    {!isNaN(totalIssueQuantity) &&
                      Number(totalIssueQuantity).toFixed(3)}
                  </Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2} />
              </Table.Summary.Row>
            </>
          );
        }}
      />
      {selectedRowKeys.length > 0 && (
        <Descriptions title="" bordered style={{ marginTop: 15 }} size="small">
          <Descriptions.Item
            label="Material Type"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 && selectedStocks[0].stockType.code}
          </Descriptions.Item>
          <Descriptions.Item
            label="Material Description"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 && selectedStocks[0].stockType.name}
          </Descriptions.Item>
          <Descriptions.Item
            label="# of Items"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length}
          </Descriptions.Item>
          <Descriptions.Item
            label="Total Issue Quantity"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 &&
              Number(
                selectedStocks
                  .map((item) => item.issueQuantity)
                  .reduce((prev, next) => prev + next)
              ).toFixed(2)}
          </Descriptions.Item>
          {/* <Descriptions.Item
            label="Gross Weight"
            span={3}
            contentStyle={{ fontWeight: "bold" }}
            labelStyle={{ fontWeight: "bold" }}
          >
            {selectedStocks.length > 0 &&
              Number(
                selectedStocks
                  .map((item) => item.grossWeight)
                  .reduce((prev, next) => prev + next)
              ).toFixed(2)}
          </Descriptions.Item> */}
        </Descriptions>
      )}
    </div>
  );
};

export default StockSelection;
